import api, { resetRetry } from '../Api'

export default async function refresh ( { rtoken } ) {

    resetRetry()

    return api.post( '/refresh', { rtoken: rtoken } )

}